import fetch from '@/utils/fetch';

export function menuCreate(params){

     return fetch({

         url:'ManageRule/ManageRule/addOrUdateOrganization',
         method:"post",
         data:params

     })

}

export function getMenu(params){

     return fetch({

         url:'ManageRule/ManageRule/getOrganizationAndPostTree',
         method:"post",
         data:params

     })

}

export function delDot(params){

     return fetch({

         url:'ManageRule/ManageRule/delOrganizationAndPost',
         method:"post",
         data:params

     })

}



// WEBPACK FOOTER //
// ./src/api/pgMent/sectMent.js